export const navigation = [
  {
    title: 'Assignment',
    url: '/instructor/settings/assignments'
  },
  {
    title: 'Roster',
    url: '/instructor/settings/roster'
  }
];

export const gameCreateItemsQuestionsColumns = [
  'Assets',
  'Liabilities',
  'Equity',
  'Revenues',
  'Expenses'
];

export const gameCreateItemsOptionsClassification = [
  'Balance Sheet',
  'Income Statement'
];

export const gameCreateItemsOptionsNormal = [
  'Debit',
  'Credit'
];

export const scenarioLevelsDescription = {
  'Account Classification': [
    'The Elements of the Financial Statements: At this level, the 5 Elements of financial statements will fall one by one.: You have to sort each falling Element to the correct financial statement.',
    'The Accounts of the Financial Statements: At this level, several Accounts of financial statements will fall one by one.: You have to sort each falling Account to the correct Elements of the financial statement.'
  ],
  'Classification': [
    'The Elements of the Financial Statements: At this level, the 5 Elements of financial statements will fall one by one.: You have to sort each falling Element to the correct financial statement.',
    'The Accounts of the Financial Statements: At this level, several Accounts of financial statements will fall one by one.: You have to sort each falling Account to the correct Elements of the financial statement.'
  ],
  'Normal Balance': [
    'The Elements of the Financial Statements: At this level, the 5 Elements of financial statements will fall one by one.: You have to sort each falling Element to its correct Normal Balance.',
    'The Accounts of the Financial Statements: At this level, several Accounts of financial statements will fall one by one.: You have to sort each falling Account to its correct Normal Balance.',
  ],
  'Balanced Equation': [
    'Elements Impacted: At this level, you are going to review a series of transactions and have to decide how each transaction impacts the Balance Sheet Elements.: In Level I, you have to decide if the transaction increases or decreases Assets, Liabilities, and Equity.',
    'Accounts Impacted: In Level 2, you\'ll need to make an additional decision. You’ll need to determine which accounts will be impacted by each transaction.',
    'Debits & Credits: In this level, you\'ll need to make a third decision. You’ll need to determine which account should be debited and credited for each transaction.'
  ],
  'The Principles': [
    'Elements Impacted: At this level, you are going to review a series of transactions and have to decide how each transaction impacts the Balance Sheet Elements.: In Level I, you have to decide if the transaction increases or decreases Assets, Liabilities, and Equity.',
    'Accounts Impacted: In Level 2, you\'ll need to make an additional decision. You’ll need to determine which accounts will be impacted by each transaction.',
    'Debits & Credits: In this level, you\'ll need to make a third decision. You’ll need to determine which account should be debited and credited for each transaction.'
  ]
};

export const designTypesMap = {
  'Account Classification': {
    'class-elements': ['1'],
    'class-default': ['2'],
    'class-tricky': ['3'],
    'classified-multistep': ['4'],
    'real-public-co': ['5']
  },
  'Normal Balance': {
    'norm-elements': ['1'],
    'norm-default': ['2'],
    'norm-tricky': ['3']
  },
  'Balanced Equation': {
    'increase-decrease': ['1'],
    // "Debit and Credit" requires students to make BOTH the
    // increase/decrease and debit/credit decisions per transaction.
    // The picker key IS `debit-credit2` end-to-end — it is what gets
    // stored on the level's `name` field, so the tutorial + transition
    // pages can route to the layered experience. Legacy `debit-credit`
    // levels (single decision per transaction) exist as grandfathered
    // records and are handled separately by the game-side code.
    'debit-credit2': ['1', '2'],
    'accounts-impacted': ['1', '3'],
    'income-statement-impact': ['1', '3'],
    'all-types': ['1', '2', '3']
  },
  'The Principles': {
    'assumptions-principles-constraints': ['4'],
    'revenue-recognition': ['1'],
    'expense-recognition': ['2'],
    'revenue-expense': ['3']
  }
};